import {useEffect, useRef} from 'react';

export function useOnChange<T>(val: T, onChange: (prev: T | undefined, cur: T) => unknown) {
    const prev = useRef<T | undefined>(undefined);
    useEffect(() => {
        onChange(prev.current, val);
        prev.current = val;
    }, [val]);
}
